import { UI_Grid } from 'ui/components/4-habitats/Grid/Grid';
import styles from './Accordion.module.scss';
import { UI_GridCell } from 'ui/components/4-habitats/Grid/GridCell';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import classNames from 'classnames';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_TopLevelGrid } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGrid';
import { UI_TopLevelGridCell } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGridCell';
import { UI_Kicker, UI_KickerProps } from 'ui/components/1-atoms/Kicker/Kicker';
import ColorOptions from 'helpers/types';
import { UI_AccordionItem, UI_AccordionItemProps } from 'ui/components/2-molecules/AccordionItem/AccordionItem';

export interface UI_AccordionProps {
	title?: string;
	description?: string;
	items: UI_AccordionItemProps[];
	kicker?: UI_KickerProps;
	bgColor?: ColorOptions;
}

export const UI_Accordion: React.FC<UI_AccordionProps> = ({ items, title, kicker, bgColor, description }) => {
	return (
		<div className={classNames(styles.Accordion, styles[`u-color___${bgColor}`])}>
			<UI_Container width="Standard">
				<UI_TopLevelGrid wrap container>
					<UI_TopLevelGridCell desktopWidth="16col" mobileWidth="100">
						{kicker && <UI_Kicker {...kicker} className={classNames(styles.Accordion_kicker, 'u-bottom-padding--xxl')} />}
						{title && (
							<UI_Heading headingLevel="h2" style="xl" className={styles.Accordion_heading}>
								{title}
							</UI_Heading>
						)}
					</UI_TopLevelGridCell>
					<UI_TopLevelGridCell
						desktopWidth="15col"
						desktopOffset="2col"
						offsetDirection="right"
						mobileWidth="100"
						className={styles.Accordion_grid}
					>
						{description && (
							<UI_Grid wrap={true}>
								<UI_GridCell desktopWidth="50" mobileWidth="100" key={'desc'} className={styles.Accordion_gridCell}>
									<p className={styles.Accordion_description}>{description}</p>
								</UI_GridCell>
							</UI_Grid>
						)}
						<UI_Grid wrap={true}>
							<UI_GridCell desktopWidth="50" mobileWidth="100" className={styles.Accordion_gridCell}>
								{items
									?.filter((_, index) => index % 2 === 0)
									.map((item, index, arr) => (
										<UI_AccordionItem borderBotLg={true} last={index === arr.length - 1} {...item} key={index} />
									))}
							</UI_GridCell>
							<UI_GridCell desktopWidth="50" mobileWidth="100" className={styles.Accordion_gridCell}>
								{items
									?.filter((_, index) => index % 2 === 1)
									.map((item, index, arr) => <UI_AccordionItem last={index === arr.length - 1} {...item} key={index} />)}
							</UI_GridCell>
						</UI_Grid>
					</UI_TopLevelGridCell>
				</UI_TopLevelGrid>
			</UI_Container>
		</div>
	);
};
